import { FC } from "react";
import { observer } from "mobx-react-lite";
import * as M from "moment";
import { Layout, ITabs } from "../../../../ui-kit";
import { ITab } from "../../../../ui-kit/Tabs/Tabs";
import AnalyticalReport from "./AnalyticalReport";
import DailyViolationsReport from "./DailyViolationsReport";
import Constants from "../../../../constants/Common";
import sitPanelReports from "../../../../store/sitPanelReportsStore";
import { useBreadcrumbs } from "../../../../hooks/useBreadcrumbs";
import Paths from "../../../../constants/PathsBreadcrumbs";

export interface IReport {
  columns?: Array<any>;
}

const SitPanelReports: FC = observer(() => {
  useBreadcrumbs(Paths.spReports);

  const columns = [
    {
      title: "Дата и время формирования",
      dataIndex: "created",
      key: "created",
      // sortable: true,
      render: (date: Date) =>
        date ? M(date).format(Constants.dateTimeFormat) : "",
    },
    {
      title: "Срок отчёта",
      key: "period",
      render: (record) => {
        if (record.dateFrom && record.dateTo) {
          return (
            M(record.dateFrom).format(Constants.dateTimeFormat) +
            " - " +
            M(record.dateTo).format(Constants.dateTimeFormat)
          );
        }
        if (record.dateFrom && !record.dateTo) {
          return M(record.dateFrom).format(Constants.dateTimeFormat);
        }
        if (!record.dateFrom && record.dateTo) {
          return M(record.dateTo).format(Constants.dateTimeFormat);
        }
        return "";
      },
    },
    {
      title: "Исходный отчёт",
      dataIndex: "fileId",
      key: "fileId",
      render: (fileId) => {
        return fileId ? (
          <a
            onClick={(e) => {
              e.stopPropagation();
              sitPanelReports.downloadDoneReport(fileId);
            }}
          >
            Скачать
          </a>
        ) : null;
      },
    },
    {
      title: "Актуализированный отчёт",
      dataIndex: "newFileId",
      key: "newFileId",
      render: (newFileId) => {
        return newFileId ? (
          <a
            onClick={(e) => {
              e.stopPropagation();
              sitPanelReports.downloadDoneReport(
                newFileId,
                "Актуализированный отчёт",
              );
            }}
          >
            Скачать
          </a>
        ) : null;
      },
    },
  ];

  const initialTabs: Array<ITab> = [
    {
      name: "Аналитическая справка",
      key: "AnalyticalReport",
      content: <AnalyticalReport />,
    },
    {
      name: "Суточная сводка по нарушениям",
      key: "DailyViolationsReport",
      content: <DailyViolationsReport columns={columns} />,
    },
  ];

  return (
    <Layout>
      <ITabs tabs={initialTabs}></ITabs>
    </Layout>
  );
});

export default SitPanelReports;
